import { Action, ActionType } from "models/stressCheck/updateStressCheck";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface UpdateStressCheckReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  updateStressCheckResponse?: IResponse;
}

const defaultState: UpdateStressCheckReducerType = {
  loading: false,
  error: null,
  saved: false,
  updateStressCheckResponse: undefined,
};

export const updateStressCheckReducer =
  createReducer<UpdateStressCheckReducerType>(defaultState, {
    [ActionType.UPDATE_STRESS_CHECK](state: UpdateStressCheckReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_STRESS_CHECK_ERROR](
      state: UpdateStressCheckReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_STRESS_CHECK_SUCCESS](
      state: UpdateStressCheckReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        updateStressCheckResponse: action.payload,
      };
    },

    [ActionType.RESET_UPDATE_STRESS_CHECK](
      state: UpdateStressCheckReducerType
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        updateStressCheckResponse: undefined,
      };
    },
  });
